import Warning from "../../../base/Warning";

const CheatingWarning = () => {
    return <Warning>Правильні відповіді не відображаються, якщо тест відкрито в різних вкладках</Warning>;
};

export default CheatingWarning;